module.exports = __webpack_public_path__ + "img/0Q3A7692_L_Black_MockedUp.adf3d799.jpg";